import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

const AccessibilityMeta = () => {
    const { i18n } = useTranslation();
    const isPolish = i18n.language === "pl";

    return (
        <Helmet>
            {isPolish ? (
                <meta
                    name="Deklaracja dostępności - Repozytorium Systemów Informacyjnych"
                    content="https://rsi.stat.gov.pl/"
                />
            ) : (
                <meta
                    name="Accessibility declaration - Information Systems Repository"
                    content="https://rsi.stat.gov.pl/en"
                />
            )}
        </Helmet>
    );
};

export default AccessibilityMeta;
